'use client';

import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useFinancingContext } from '~/context/flp/FinancingContext';
import useRefreshTerms from '~/hooks/flp/services/useRefreshTerms';
import useTermsUpdated from '~/hooks/flp/useTermsUpdated';
import {
  useNativeMessageDispatcher,
  useNativeMessageListener
} from '~/native/flp';

type OwnProps = {
  isLoggedIn: boolean;
};

export default function FinancingData({ isLoggedIn }: OwnProps) {
  const { isInitialized } = useFinancingContext();
  const refreshTerms = useRefreshTerms();

  // Initialize financing data if user is logged in
  useEffectOnce(
    () => {
      refreshTerms(true);
    },
    [refreshTerms],
    isLoggedIn
  );

  useNativeMessageListener();
  useNativeMessageDispatcher(!isLoggedIn || isInitialized);
  useTermsUpdated(isLoggedIn);

  return null;
}
